import { API_ENDPOINTS } from "@/api/services/recognized/apiEndpoint";
import { baseApi } from "@/utils/baseApi";

export const employeeListApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRecognizedDataEmployee: builder.query({
      query: () => ({
        url: API_ENDPOINTS.GET_RECOGNIZED_EMPLOYEE(),
        method: "GET",
      }),
      providesTags: ["Recognized"],
      transformResponse: (response) => response?.data,
    }),

    getRecognizedData: builder.query({
      query: () => ({
        url: API_ENDPOINTS.GET_RECOGNIZED(),
        method: "GET",
      }),
      providesTags: ["Recognized"],
      transformResponse: (response) => response.data,
    }),
    addRecognizedData: builder.mutation({
      query: (payload) => ({
        url: API_ENDPOINTS.ADD_RECOGNIZED(),
        method: "POST", // or "PUT", depending on your backend
        body: payload,
      }),
      invalidatesTags: ["Recognized"], // optionally invalidate cache
      transformErrorResponse: (res) => res?.data?.data || {},
    }),

    updateRecognizedData: builder.mutation({
      query: ({ id, payload }) => ({
        url: API_ENDPOINTS.UPDATE_RECOGNIZED(id),
        method: "PUT", // or "PUT", depending on your backend
        body: payload,
      }),
      invalidatesTags: ["Recognized"], // optionally invalidate cache
      transformErrorResponse: (res) => res?.data || {},
    }),

    deleteRecognizedData: builder.mutation({
      query: (id) => ({
        url: API_ENDPOINTS.DELETE_RECOGNIZED(id),
        method: "DELETE",
      }),
      invalidatesTags: ["Recognized"], // optionally invalidate cache
      transformErrorResponse: (res) => res?.data || {},
    }),
  }),
});

export const {
  useGetRecognizedDataQuery,
  useAddRecognizedDataMutation,
  useUpdateRecognizedDataMutation,
  useDeleteRecognizedDataMutation,

  // get employee info api
  useGetRecognizedDataEmployeeQuery,
} = employeeListApi;
